<template>
	<svg :alt="alt" width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M7.75 10.75H36.25V33.25H7.75V10.75Z" fill="white" stroke="#0074B5" stroke-width="1.5"/>
	</svg>
</template>

<script>
export default {
	props: {
		alt: String
	}
};
</script>
